import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer'; 
const AcademicEthos = () => {
    useEffect(() => {
        document.title = 'Academic Ethos -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>Academic Ethos </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>Academic</li>
                            <li>|</li>
                            <li> Academic Ethos </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                    <p><strong>1.</strong> The culture and ethos  of the School promotes respect as well as healthy and productive attitude towards learning, life and work. We try to  develop an ethos of ambition and achievement, striving for the maximum for every learner. Children and young people are proud of their learning, their progress, attainment and achievements. Their work is displayed well in classrooms, in public areas. Achievements both within and out  the school are recognised, valued and celebrated.</p> 
                    <p><strong>2.</strong> Children, young people and staff develop self-confidence, self-esteem and positive views about themselves and the school, through taking part in an extensive and varied programme of activities during school hours. Respect for diversity and understanding of differences and values are given a high value in the school. Students are given encouragement to share their views and act as positive role models for others.</p> 
                    <p><strong>3.</strong> Approaches to promoting positive behaviour are encouraged. We believe strongly in academic excellence, in developing questioning, analytical and creative minds, but also knowing how to live in company. Education is also about sharing, and the classroom is only one of the sites where our students learn together. We want them to leave with confidence and a desire to carry on learning, and to put ideas into action, because they are inspired to help make a more tolerant and safer world.</p>
                    </div>
                </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default AcademicEthos